import type { AppState, RuntimeGraphKind } from './appState.js';
import type { DataGraphDef, QueryGraphDef } from '../graph/dataGraph.js';
import type { EventGraphDef } from '../graph/eventGraph.js';

export function currentRuntimeGraphId(appState: AppState, kind: RuntimeGraphKind): string | null {
  return appState.editorContext.mode === `${kind}-library`
    ? appState.editorContext.libraryItemId ?? null
    : null;
}

export function currentDataGraphId(appState: AppState): string | null {
  return currentRuntimeGraphId(appState, 'data');
}

export function runtimeGraphDefinition(appState: AppState, kind: 'data', graphId: string): DataGraphDef | undefined;
export function runtimeGraphDefinition(appState: AppState, kind: 'event', graphId: string): EventGraphDef | undefined;
export function runtimeGraphDefinition(appState: AppState, kind: 'query', graphId: string): QueryGraphDef | undefined;
export function runtimeGraphDefinition(
  appState: AppState,
  kind: RuntimeGraphKind,
  graphId: string,
): DataGraphDef | EventGraphDef | QueryGraphDef | undefined {
  const stored = kind === 'data' ? appState.dataGraphs[graphId] : kind === 'event' ? appState.eventGraphs[graphId] : appState.queryGraphs[graphId];
  return currentRuntimeGraphId(appState, kind) === graphId
    ? { nodes: appState.nodes, edges: appState.edges }
    : stored;
}
